<template>
  <router-view />
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
};
</script>
